export var F2_PAGES;
(function (F2_PAGES) {
    F2_PAGES["HOME"] = "home";
    F2_PAGES["TOPIC"] = "topic";
})(F2_PAGES || (F2_PAGES = {}));
export var CurrentPageType;
(function (CurrentPageType) {
    CurrentPageType["WIKI_RELATED"] = "WIKI_RELATED";
    CurrentPageType["FAN_CENTRAL"] = "FAN_CENTRAL";
    CurrentPageType["F2_HOMEPAGE"] = "F2_HOMEPAGE";
    CurrentPageType["F2_TOPIC_PAGE"] = "F2_TOPIC_PAGE";
    CurrentPageType["F2_EDITORIAL_PAGE"] = "F2_EDITORIAL_PAGE";
})(CurrentPageType || (CurrentPageType = {}));
